export const EMAIL_PATTERN =
  /^([a-zA-Z0-9.]{4,})@([a-zA-Z0-9]{4,}).([\w]+)((.([\w]+))*)$/;

export const TEXT_WITH_SPACE_PATTERN_MAX_30 = /^[\w\s,'.?!()]{4,30}$/;

export const TEXT_WITH_SPACE_PATTERN_MAX_70 = /^[\w\s,'.?!()]{4,70}$/;

export const TEXT_WITH_SPACE_PATTERN_MAX_16 = /^[\w\s,'.?!()]{4,16}$/;

export const TEXT_WITH_SPACE_AND_SPECIAL_CHAR_PATTERN_MAX_400 =
  /^[\w\s!:/,.?()]{4,400}$/;

export const NUMERIC_PATTERN = /^-?\d*(\.\d*)?$/;
